var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from "mobx";
import { RemoteData } from "../Infra/RemoteData";
export class JobManagementManager {
    constructor(jobManagementService, invalidator) {
        this.jobManagementService = jobManagementService;
        this.actionLoading = false;
        this.lastActionResult = null;
        this.queues = new RemoteData(invalidator, async () => {
            const response = await this.jobManagementService.getQueues();
            return response.queues;
        });
        this.schedules = new RemoteData(invalidator, async () => {
            const response = await this.jobManagementService.getSchedules();
            return response.schedules;
        });
    }
    async retryJob(jobId, fromArchive) {
        this.actionLoading = true;
        try {
            const result = await this.jobManagementService.retryJob(jobId, fromArchive);
            this.lastActionResult = result;
            this.queues.reload();
            return result;
        }
        finally {
            this.actionLoading = false;
        }
    }
    async cancelJob(jobId) {
        this.actionLoading = true;
        try {
            const result = await this.jobManagementService.cancelJob(jobId);
            this.lastActionResult = result;
            this.queues.reload();
            return result;
        }
        finally {
            this.actionLoading = false;
        }
    }
    async resumeJob(jobId) {
        this.actionLoading = true;
        try {
            const result = await this.jobManagementService.resumeJob(jobId);
            this.lastActionResult = result;
            this.queues.reload();
            return result;
        }
        finally {
            this.actionLoading = false;
        }
    }
    async deleteQueue(queueName) {
        this.actionLoading = true;
        try {
            const result = await this.jobManagementService.deleteQueue(queueName, true);
            this.lastActionResult = result;
            this.queues.reload();
            return result;
        }
        finally {
            this.actionLoading = false;
        }
    }
    async purgeQueue(queueName) {
        this.actionLoading = true;
        try {
            const result = await this.jobManagementService.purgeQueue(queueName);
            this.lastActionResult = result;
            this.queues.reload();
            return result;
        }
        finally {
            this.actionLoading = false;
        }
    }
    refresh() {
        this.queues.reload();
        this.schedules.reload();
    }
    clearLastActionResult() {
        this.lastActionResult = null;
    }
}
__decorate([
    observable
], JobManagementManager.prototype, "actionLoading", void 0);
__decorate([
    observable
], JobManagementManager.prototype, "lastActionResult", void 0);
